'use client';
import { factory, Typography, Button, omitText } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { useState } from 'react';
import classes from './ZipCodeInputField.module.css.mjs';

const ZipCodeInputField = factory((props, ref) => {
  const {
    handleSubmit,
    onSubmit,
    id = "zipcode-input",
    label = "Zip Code",
    placeholder,
    CTA,
    className,
    inputValue,
    onInputChange,
    ...rest
  } = props;
  const [value, setValue] = useState(null);
  return /* @__PURE__ */ React.createElement(
    "form",
    {
      className: "waitlist-form",
      onSubmit: (event) => {
        event.preventDefault();
        onSubmit?.(event);
        const target = event.target;
        handleSubmit(target.elements[0].value || "");
      },
      onInvalid: (e) => {
        e.preventDefault();
      },
      ...rest
    },
    /* @__PURE__ */ React.createElement("div", { ref, className: clsx(classes.inputContainer, "kohler-input-field-wrapper", className) }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        size: "h4",
        component: "input",
        id,
        type: "text",
        className: clsx(classes.input),
        placeholder: placeholder || label,
        ref,
        "aria-label": rest["aria-label"],
        autoCapitalize: "off",
        autoCorrect: "off",
        maxLength: 75,
        min: 0,
        value: inputValue ?? value ?? "",
        onChange: (e) => {
          if (typeof onInputChange === "function") {
            onInputChange(e);
          } else {
            const newValue = e.target.value;
            setValue(newValue.length === 0 ? null : newValue);
          }
        }
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "primary",
        size: "small",
        type: "submit",
        disabled: !inputValue && !value,
        className: classes.inputFieldButton,
        ...omitText(CTA || {})
      },
      CTA?.text || "Submit"
    ))
  );
});

export { ZipCodeInputField };
